import { logOneDSDatapoint } from "../OneDsWrapper";
import { ADDINS_TELEMETRY_SENTINEL } from "../plugins/SchemaEnforcementPlugin";
import type { IExtendedTelemetryItem } from "@microsoft/1ds-analytics-js";
import type { CoreAnalyticsOptions } from "owa-analytics-types";
import { getAccountKeyForMailboxInfo, type MailboxInfo } from "owa-client-types";
import { getAnalyticsFlightsAndAppSettings } from "../settings/getAnalyticsFlightsAndAppSettings";

export async function logAddinsTelemetryEvent(tenantToken: string, item: IExtendedTelemetryItem, analyticsOptions?: CoreAnalyticsOptions, mailboxInfo?: MailboxInfo): Promise<void> {
    const accountKey = mailboxInfo && getAccountKeyForMailboxInfo(mailboxInfo);
    
    // Mark the event so SchemaEnforcementPlugin bypasses both table and
    // column guards.  Addin events (Fluid/Loop, Feedback SDK, etc.) use
    // their own schemas that are outside OWA's control.
    // Only stamp when the plugin is active (flight on) to avoid leaking
    // the sentinel as a real Aria column.
    if (getAnalyticsFlightsAndAppSettings()?.enableSchemaEnforcement) {
        item.data ??= {};
        item.data[ADDINS_TELEMETRY_SENTINEL] = 1;
    }
    
    // Returning is important so the errors can be handled by the main thread.
    return logOneDSDatapoint({
        tenantToken,
        item,
        accountKey,
        analyticsOptions,
        skipCommonProperties: true,
    });
}
